import demoModeConfig from "common/demoModeConfig.json";

export const resolveActiveLogisticCompanyId = (logisticCompanyId, user) => {
  if (logisticCompanyId === 0) {
    return user?.logisticcompany_id;
  }

  return logisticCompanyId || user?.logisticcompany_id;
};

export const getLogisticCompanySwitcherState = ({
  logisticCompanyId,
  user,
  managedLogisticCompanies = {}
}) => {
  const allAreasOption = demoModeConfig.allAreasOption || {};
  const hasAllAreasAccess = (
    allAreasOption.enabledForLogisticCompanyIds || []
  ).some(id => !!managedLogisticCompanies[id]);
  const showAllAreasOption =
    hasAllAreasAccess && Boolean(allAreasOption.label);
  const showSwitcher =
    Object.keys(managedLogisticCompanies).length > 1 || showAllAreasOption;

  const isAllAreasSelected = logisticCompanyId === 0 && showAllAreasOption;
  const activeLogisticCompanyId = isAllAreasSelected
    ? 0
    : resolveActiveLogisticCompanyId(logisticCompanyId, user);
  const activeCompany = managedLogisticCompanies[activeLogisticCompanyId] || {};

  const hasDemoModeAccess = demoModeConfig.enabledForLogisticCompanyIds.some(
    id => !!managedLogisticCompanies[id]
  );

  let demoModeEnabled = false;
  try {
    demoModeEnabled =
      localStorage.getItem(demoModeConfig.storageKey) === "true";
  } catch (error) {
    demoModeEnabled = false;
  }

  const shouldAnonymizeNames = hasDemoModeAccess && demoModeEnabled;
  const logisticcompanies = Object.values(managedLogisticCompanies).sort(
    (left, right) => left.id - right.id
  );
  const anonymizedNameById = logisticcompanies.reduce((acc, company, index) => {
    const anonymizedName = demoModeConfig.namePattern.replace(
      "{index}",
      index + 1
    );
    return {
      ...acc,
      [company.id]: anonymizedName
    };
  }, {});
  const menuItems = showAllAreasOption
    ? [{ id: 0, name: allAreasOption.label }, ...logisticcompanies]
    : logisticcompanies;

  const currentLabel = isAllAreasSelected
    ? allAreasOption.label
    : shouldAnonymizeNames
      ? anonymizedNameById[activeCompany.id] || activeCompany.name
      : activeCompany.name;

  const resolveMenuItemLabel = (id, name) => {
    if (shouldAnonymizeNames && id !== 0) {
      return anonymizedNameById[id] || name;
    }

    return name;
  };

  return {
    showSwitcher,
    activeLogisticCompanyId,
    menuItems,
    currentLabel,
    resolveMenuItemLabel
  };
};

export const getActiveLogisticCompanyName = ({
  logisticCompanyId,
  user,
  managedLogisticCompanies
}) => {
  const { currentLabel } = getLogisticCompanySwitcherState({
    logisticCompanyId,
    user,
    managedLogisticCompanies
  });

  return currentLabel || "TrackCode";
};
